import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import ProgramExecutor from '../lab2/ProgramExecutor';
import moduleStyles from './ai-visualization-preview.module.scss';
/**
 * Previews the output of the AI block in Dance Party.
 */
var AiVisualizationPreview = function (_a) {
    var id = _a.id, code = _a.code, size = _a.size, durationMs = _a.durationMs;
    var songMetadata = useSelector(function (state) { return state.dance.currentSongMetadata; });
    var executorRef = useRef(null);
    // Create the executor on mount to make sure the preview div exists.
    useEffect(function () {
        executorRef.current = new ProgramExecutor(id, function () { return undefined; }, // no-op on puzzle complete
        true, // treat this as a readonly workspace
        false // no replay log
        );
    }, [id]);
    useEffect(function () {
        if (songMetadata === undefined || executorRef.current === null) {
            return;
        }
        if (!executorRef.current.isLivePreviewRunning()) {
            executorRef.current.startLivePreview(code, songMetadata, durationMs);
        }
        else {
            executorRef.current.updateLivePreview(code, songMetadata, durationMs);
        }
    }, [songMetadata, code, durationMs]);
    var containerRef = useRef(null);
    // HACK: P5 Play hardcodes the canvas size to 400x400 no matter what the container
    // size is. This forces the canvas size to match the container size (200x200).
    useEffect(function () {
        if (containerRef.current) {
            var canvas = containerRef.current.children[0];
            if (canvas) {
                canvas.style.width = size + 'px';
                canvas.style.height = size + 'px';
            }
        }
    }, [containerRef, size]);
    // Destroy on unmount
    useEffect(function () { return function () { var _a; return (_a = executorRef.current) === null || _a === void 0 ? void 0 : _a.destroy(); }; }, []);
    return (React.createElement("div", null,
        React.createElement("div", { id: id, style: { width: size, height: size }, className: moduleStyles.previewVisualization, ref: containerRef })));
};
export default AiVisualizationPreview;
